import { lazy, Suspense, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import queryString from 'query-string';

import 'react-toastify/dist/ReactToastify.css';

const List = lazy(() => import('./List'));
const View = lazy(() => import('./View'));
const Map = lazy(() => import('./Map'));

const MODES = {
    List: 'list',
    View: 'view',
    Map: 'map'
};

function Listings(props) {
    const params = queryString.parse(window.location.search);
    let defaultMode = props.domElement.getAttribute('data-mode');

    if (!defaultMode) {
        defaultMode = params.propertyListingID ? 'view' : 'list';
    }

    const [mode, setMode] = useState(defaultMode);

    if (mode == MODES.View) {
        return (
            <>
                <View
                    {...props}
                    {...params}
                    onFail={() => {
                        setMode('list');
                    }}
                />
                <ToastContainer
                    position="bottom-right"
                    theme="colored"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
            </>
        );
    } else if (mode == MODES.Map) {
        return <Map {...props} {...params} />;
    }

    return (
        <Suspense>
            <List {...props} {...params} />
        </Suspense>
    );
}

export default Listings;
